export default function validationSuppression(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('DELETE_FORBIDDEN_IF_REFERENCED_ON_OT') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: 'listeAccessoire.messages.error.accessoireLierOT',
        parametres: {
          libelle: params[1],
          code: params[2].replace('[', '').replace(']', '').split(',').join(', '),
        },
      });
    }
    if (message.indexOf('DELETE_FORBIDDEN_IF_REFERENCED_ON_DISPOSITIF') === 0) {
      const params = message.split('|')[0].split('@');
      messages.push({
        message: 'listeAccessoire.messages.error.accessoireLierPatrimoine',
        parametres: {
          libelle: params[1],
          code: params[2].replace('[', '').replace(']', '').split(',').join(', '),
        },
      });
    }
  });
}
